import { Box, Divider, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { GlobalSearchService } from 'service/global-search.service';
import zeplinColor from 'theme/Color';
import Card from '../Card';
import QuickActionButton, { QuickActionButtonVariantType } from '../QuickActionButton';

const RecentlyOpen = ({ handleCloseSearch }: { handleCloseSearch: () => void }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    try {
      setLoading(true);
      const fetchRecentSearches = async () => {
        const response = await GlobalSearchService.getRecentSearchResults();
        setData(response.recent);
      };

      fetchRecentSearches();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, []);

  if (loading) return <>Loading...</>;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      <Box>
        <Typography variant='responsiveBody3' sx={{ color: zeplinColor.Neutral8 }}>
          Recent Open
        </Typography>
        {data.length === 0 ? (
          <Box>
            <Typography variant='responsiveBody3'> No recently opened searches</Typography>
          </Box>
        ) : (
          data.map((item: any) => <Card key={item.id} category='recent' product={item} />)
        )}
      </Box>

      <Divider sx={{ borderColor: zeplinColor.Neutral5 }} />

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Typography variant='responsiveBody3' sx={{ color: zeplinColor.Neutral8 }}>
          Quick Actions
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '8px' }}>
          {['task', 'lead', 'deal'].map((item) => (
            <QuickActionButton
              key={item}
              variant={item as QuickActionButtonVariantType}
              handleCloseSearch={handleCloseSearch}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default RecentlyOpen;
